import { AppMetricsTimeSeriesTotalIndividualMapper } from '../../../infrastructure/mappers/team-metrics/app-metrics-time-series-total-individual.mapper';
import { GetAppMetricsTimeSeriesTotalsIndividualRequestDto } from '../../dtos/team-metrics/get-app-metrics-time-series-totals-individual.request.dto';
import { GetAppMetricsTimeSeriesTotalsIndividualResponseArray } from '../../dtos/team-metrics/get-app-metrics-time-series-totals-individual.response.dto';
import { GetAppMetricsTimeSeriesTotalIndividualQuery } from '../../../interface/queries/team-metrics/get-app-metrics-time-series-total-individual.query';
import { LogManager } from '../../../common/port/log/log.manager.port';

export class GetAppMetricsTimeSeriesTotalIndividualController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAppMetricsTimeSeriesTotalIndividualQuery,
    protected readonly mapper: AppMetricsTimeSeriesTotalIndividualMapper
  ) {}

  async get(
    props: GetAppMetricsTimeSeriesTotalsIndividualRequestDto
  ): Promise<GetAppMetricsTimeSeriesTotalsIndividualResponseArray> {
    try {
      const result = await this.query.execute(props);
      return result.map((record) => this.mapper.toResponse(record));
    } catch (error) {
      throw new Error(
        `AppMetricsTimeSeriesTotalIndividualComponentController.get encountered an error ${error}`
      );
    }
  }
}
